import React, { useContext } from 'react';
import AppContext from '../../AppContext';
import styles from '../RowBuilder/Row.module.css';
import HeaderHelmet, { HeaderHelmetProps } from './HeaderHelmet';
import { INDUSTRY_MEAN_LABEL } from '../model/ColumnLabels';

interface IrisRowHeaderProps {
  helmet: HeaderHelmetProps;
  showPercentPointChange?: boolean;
  showDollarChange?: boolean;
}

export default function IrisRowHeader({
  helmet,
  showPercentPointChange,
  showDollarChange
}: IrisRowHeaderProps) {
  const { showBenchmark, showIndustryMean, year, activeYearsMode } = useContext(AppContext);
  const yearCount = activeYearsMode === 'TEN' ? 10 : 5;
  const yearColsStyle = { '--year-cols': yearCount } as React.CSSProperties;
  return (
    <div
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse} ${!showIndustryMean ? styles.hideIndustryMean : ''}`}
      style={yearColsStyle}
      data-testid="iris-row-header">
      <HeaderHelmet {...helmet} />
      <h5 className="column_align_right" aria-hidden={!showPercentPointChange}>
        {showPercentPointChange ? '%/Pt. Change' : ''}
      </h5>
      <h5 className="column_align_right" aria-hidden={!showDollarChange}>
        {showDollarChange ? '$ Change' : ''}
      </h5>
      <h5 className="column_align_right" aria-hidden="true"></h5>
      <h5 className="column_align_right" aria-hidden="true"></h5>
      <h5 className="column_align_right">{`${INDUSTRY_MEAN_LABEL} *`}</h5>
      {Array.from({ length: yearCount }, (_, i) => year - i).map((yr) => (
        <h5 key={`iris-year-${yr}`} className="column_align_right">
          {yr}
        </h5>
      ))}
    </div>
  );
}
